var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "block-container" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-single", staticStyle: { overflow: "visible" } },
          [
            _c("div", { staticClass: "title" }, [_vm._v("请求单号")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.no))])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("服务号")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.svcNo || "无"))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("创建时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.ts))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("请求时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.requestTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("预约上门时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.planTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("要求响应时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcReqVoucher.yqRspTimeMi) + "   分钟")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("要求到达时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcReqVoucher.yqArriveTimeMi) + "   分钟")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("要求完成时长")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcReqVoucher.yqRepairedTimeMi) + "   分钟")
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.servcReqVoucher.cancelled
          ? _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("取消原因")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.servcReqVoucher.cancelCause || "无"))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.servcReqVoucher.servicerAcceptState == -1
          ? _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("拒绝原因")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.servcReqVoucher.servicerRefuseDesc || "无"))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("请求描述")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.requestDesc))])
          ])
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("买家名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.buyerName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("机构名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.buyerShopName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("详细地址")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.buyerShopAddr))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("联系人")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.buyerShopUserName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.servcReqVoucher.buyerShopContactTel))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("故障描述")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.troubleDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("swb-servc-req-voucher-file-detail", {
          attrs: { reqVoucherId: _vm.reqVoucherId }
        }),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("服务项")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.title))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("工单信息")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content", staticStyle: { width: "auto" } },
            [
              _vm.servcWorkVoucherList.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          attrs: { data: _vm.servcWorkVoucherList, border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "服务工单", width: "180" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.returnServcWorkVoucher(
                                                scope.row.no
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(scope.row.no))]
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "紧急状态",
                              prop: "emgLevel",
                              width: "80",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(rows) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          rows.row.emgLevel == 0
                                            ? "font-green"
                                            : rows.row.emgLevel == 1
                                            ? "font-orange"
                                            : "font-red"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.emgLevelMap[rows.row.emgLevel]
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "status",
                              label: "工单状态",
                              width: "100"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.invalid
                                      ? _c(
                                          "span",
                                          { staticClass: "font-red" },
                                          [_vm._v("已作废")]
                                        )
                                      : scope.row.closed
                                      ? _c(
                                          "span",
                                          { staticClass: "font-red" },
                                          [_vm._v("已关闭")]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "font-green" },
                                          [_vm._v(_vm._s(scope.row.status))]
                                        )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "toDoorTime",
                              label: "上门时间",
                              width: "150"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "服务完成时间" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.finished
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.finishTime))
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.tmpNo != null
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "swb-btn swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.showDeviceRepairRec(
                                                  scope.row.tmpNo
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("维保记录")]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("受理时间")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.servcReqVoucher.acceptTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("网点名称")]),
          _vm._v(" "),
          _vm.servicerCom != null && _vm.servicerCom.shopFlag
            ? _c("div", { staticClass: "content" }, [
                _c("span", [_vm._v(_vm._s(_vm.servicerCom.name))])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("网点地址")]),
          _vm._v(" "),
          _vm.servicerCom != null
            ? _c("div", [
                _vm.servicerCom.street == null && _vm.servicerCom.shopFlag
                  ? _c("div", { staticClass: "content" }, [
                      _c("span", [_vm._v(_vm._s(_vm.servicerCom.regionName))])
                    ])
                  : _c("div", { staticClass: "content" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.servicerCom.regionName) +
                            _vm._s(_vm.servicerCom.street)
                        )
                      ])
                    ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("网点联系人")]),
          _vm._v(" "),
          _vm.servicerCom != null
            ? _c("div", [
                _vm.servicerCom.shopFlag
                  ? _c("div", { staticClass: "content" }, [
                      _c("span", [_vm._v(_vm._s(_vm.servicerCom.contactName))])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("网点联系电话")]),
          _vm._v(" "),
          _vm.servicerCom != null
            ? _c("div", [
                _vm.servicerCom.shopFlag
                  ? _c("div", { staticClass: "content" }, [
                      _c("span", [_vm._v(_vm._s(_vm.servicerCom.contactTel))])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("请求信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("买家信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("服务信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("服务商信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-967d9c5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-967d9c5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcReq/ServcReqVoucherLook.vue
// module id = 2096
// module chunks = 1